import * as t from "io-ts";
import {
  createConsolidatedInvoiceTypes,
  deferredInvoicesFolderT,
} from "dora-contracts";

export {
  createDeferredInvoiceT,
  createFolderReqT,
  moveToFolderReqT,
  renameFolderReqT,
  replaceClientReqT,
  updateFolderReqT,
} from "dora-contracts";

export const {
  deferredInvoiceT,
  getClientsResponseT,
  getDeferredInvoicesResponseT,
  getFilterOptionsResponseT,
} = createConsolidatedInvoiceTypes({
  decimal: t.string,
});

export type DeferredInvoice = t.TypeOf<typeof deferredInvoiceT>;
export type DeferredInvoicesFolder = t.TypeOf<typeof deferredInvoicesFolderT>;
export type CargoStop = DeferredInvoice["cargo"]["stop"];
export type UninvoicedClients = t.TypeOf<typeof getClientsResponseT>;
export type UninvoicedFilterOptions = t.TypeOf<typeof getFilterOptionsResponseT>;
